import { render, staticRenderFns } from "./TableProviders.vue?vue&type=template&id=2416ef4f"
import script from "./TableProviders.vue?vue&type=script&lang=js"
export * from "./TableProviders.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports